import { accessibilityAnalyzerReaderQueryRuleExecutionResultsByItemType as queryRuleExecutionResultsByItemTypeV2 } from '@wix/ambassador-promote-accessibility-v2-rule-execution-result/http';
export const queryExecutionResultByItemType = async (httpClient, itemType, errorHandler) => {
  const {
    withErrorHandler
  } = errorHandler;
  const LIMIT = 200;
  const allRuleExecutionResults = [];
  let cursor;
  let lastPage = false;
  await withErrorHandler(async () => {
    do {
      const response = await httpClient.request(queryRuleExecutionResultsByItemTypeV2({
        itemType,
        paginationRequest: {
          cursor,
          maxNumberOfRecords: LIMIT
        }
      }));
      const {
        paginationResponse,
        ruleExecutionResults
      } = response.data;
      allRuleExecutionResults.push(...(ruleExecutionResults ?? []));
      cursor = paginationResponse == null ? void 0 : paginationResponse.cursor;
      lastPage = (paginationResponse == null ? void 0 : paginationResponse.lastPage) ?? false;
    } while (!lastPage);
  }, {
    errorCodesMap: {}
  });
  return allRuleExecutionResults;
};
//# sourceMappingURL=query-execution-result-by-item-type.js.map